import { useEffect, useContext } from "react";
import Header from "./Header";
import useState from "react-usestateref";
import authservices from "../services/authservices";
import { Link } from "react-router-dom";
import SubFooter from "./SubFooter";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";
const BinargeAcademy = () => {
  const [userAuth, setAuth, userAuthref] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    getSitedata();
  }, []);
  const [siteDatacomes, setSiteData] = useState("");

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);


  const getSitedata = async () => {
    try {
      const data = await authservices.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        // console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <main className="wyscale_landing_main">
        <Header />
      </main>

      <section className="dashboard_content_section">
        <div className="container">
          <div className="smart_dashboard_content" id="terms-condition">
            <h2>{t("Academyhead")}</h2>
            <h2>{t("EducationalResourceSection")}</h2>
            <div className="row">
              <div className="col-lg-12">
                <div className="dash_board_profile_content">
                  <div className="contentpage">
            <h4>{t("BinargeAcademyUserGuide")}</h4>

                    <p>{t("BinargeAcademyIs")}</p>
                    <ul>
                      {t("BinargeAcademyIs1") && <li>{t("BinargeAcademyIs1")}</li>}
                      {t("BinargeAcademyIs2") && <li>{t("BinargeAcademyIs2")}</li>}
                      {t("BinargeAcademyIs3") && <li>{t("BinargeAcademyIs3")}</li>}
                      {t("BinargeAcademyIs4") && <li>{t("BinargeAcademyIs4")}</li>}
                    </ul>
                    <p>{t("BinargeAcademyIs5")}</p>
                    <p>{t("BinargeAcademyIs6")}</p>
                    <h2>{t("BeginnerBasics")}</h2>
                    <h3>{t("WhatIsCrypto")}</h3>
                    <p>{t("WhatIsCryptocontent1")}</p>
                    <ul>
                      {t("WhatIsCrypto1") && <li>{t("WhatIsCrypto1")}</li>}
                      {t("WhatIsCrypto2") && <li>{t("WhatIsCrypto2")}</li>}
                      {t("WhatIsCrypto3") && <li>{t("WhatIsCrypto3")}</li>}
                      {t("WhatIsCrypto4") && <li>{t("WhatIsCrypto4")}</li>}
                    </ul>
                    <p>{t("WhatIsCryptocontent2")}</p>
                    <p>{t("WhatIsCryptocontent3")}</p>
                    <ul>
                      {t("WhatIsCrypto5") && <li>{t("WhatIsCrypto5")}</li>}
                      {t("WhatIsCrypto6") && <li>{t("WhatIsCrypto6")}</li>}
                      {t("WhatIsCrypto7") && <li>{t("WhatIsCrypto7")}</li>}
                    </ul>
                    <p>{t("WhatIsCryptocontent4")}</p>

                    <h3>{t("WhatAPIKey?")}</h3>
                    <p>{t("WhatAPIKeycontent1")}</p>
                    <p>{t("WhatAPIKeycontent2")}</p>
                    <ul>
                      {t("apikey1") && <li>{t("apikey1")}</li>}
                      {t("apikey2") && <li>{t("apikey2")}</li>}
                    </ul>
                    <p>{t("WhatAPIKeycontent3")}</p>
                    <ul>
                      {t("apikey3") && <li>{t("apikey3")}</li>}
                      {t("apikey4") && <li>{t("apikey4")}</li>}
                      {t("apikey5") && <li>{t("apikey5")}</li>}
                      {t("apikey6") && <li>{t("apikey6")}</li>}
                    </ul>
                    <p>{t("WhatAPIKeycontent4")}</p>
                    <h3>{t("ArbitrageTrading")}</h3>
                    <p>{t("ArbitrageTradingcontent1")}</p>
                    <ul>
                      {t("ArbitrageTrading1") && <li>{t("ArbitrageTrading1")}</li>}
                      {t("ArbitrageTrading2") && <li>{t("ArbitrageTrading2")}</li>}
                    </ul>
                    <p>{t("ArbitrageTradingcontent2")}</p>
                    <ul>
                      {t("ArbitrageTrading3") && <li>{t("ArbitrageTrading3")}</li>}
                      {t("ArbitrageTrading4") && <li>{t("ArbitrageTrading4")}</li>}
                    </ul>
                    <p>{t("ArbitrageTradingcontent3")}</p>

                    <h3> {t("StrategyDeepDives")}</h3>
                    <p> {t("StrategyDeepDivescontent1")}</p>
                    <p> {t("StrategyDeepDivescontent2")}</p>
                    <h3>{t("DCA_A")}</h3>
                    <ul>
                      {t("DCA1") && <li>{t("DCA1")}</li>}
                      {t("DCA2") && <li>{t("DCA2")}</li>}
                      {t("DCA3") && <li>{t("DCA3")}</li>}
                      {t("DCA4") && <li>{t("DCA4")}</li>}
                    </ul>
                    <p>{t("DCAStrategy")}</p>
                    <h3>{t("IntradayStrategy")}</h3>
                    <ul>
                      {(t("IntradayStrategy1")) && <li>{t("IntradayStrategy1")}</li>}
                      {(t("IntradayStrategy2")) && <li>{t("IntradayStrategy2")}</li>}
                      {(t("IntradayStrategy3")) && <li>{t("IntradayStrategy3")}</li>}
                      {(t("IntradayStrategy4")) && <li>{t("IntradayStrategy4")}</li>}
                    </ul>
                    <p>{t("IntradayTrades")}</p>


                    <h3> {t("TriangularArbitrage")}</h3>
                    <p>{t("TriangularArbitragestratagy1")}</p>
                    {t("TriangularArbitragestratagy2") && <p>{t("TriangularArbitragestratagy2")}</p>}
                    <ul>
                      {(t("TriangularArbitrage1")) && <li>{t("TriangularArbitrage1")}</li>}
                      {(t("TriangularArbitrage2")) && <li>{t("TriangularArbitrage2")}</li>}
                      {(t("TriangularArbitrage3")) && <li>{t("TriangularArbitrage3")}</li>}
                    </ul>
                      {t("TriangularArbitragestratagy3") && <p>{t("TriangularArbitragestratagy3")}</p>}
                    <ul>
                      {(t("TriangularArbitrage4")) && <li>{t("TriangularArbitrage4")}</li>}
                      {(t("TriangularArbitrage5")) && <li>{t("TriangularArbitrage5")}</li>}
                      {(t("TriangularArbitrage6")) && <li>{t("TriangularArbitrage6")}</li>}
                    </ul>

                    <h3>{t("MultiExchangeArbitrage")}</h3>
                    <p>{t("MultiExchangeArbitragecontent1")}</p>
                    <ul>
                      {t("MultiExchangeArbitrage1") && <li>{t("MultiExchangeArbitrage1")}</li>}
                      {t("MultiExchangeArbitrage2") && <li>{t("MultiExchangeArbitrage2")}</li>}
                      {t("MultiExchangeArbitrage3") && <li>{t("MultiExchangeArbitrage3")}</li>}
                      {t("MultiExchangeArbitrage4") && <li>{t("MultiExchangeArbitrage4")}</li>}
                    </ul>
                    <p>{t("MultiExchangeArbitragecontent2")}</p>
                    <ul>
                      {t("MultiExchangeArbitrage5") && <li>{t("MultiExchangeArbitrage5")}</li>}
                      {t("MultiExchangeArbitrage6") && <li>{t("MultiExchangeArbitrage6")}</li>}
                    </ul>
                    <p>{t("MultiExchangeArbitragecontent3")}</p>

                    <h3>{t("MomentumStrategy")} </h3>
                    <p>{t("MomentumStrategyIs")}</p>
                    <p>{t("MomentumStrategyIs1")}</p>
                    <p>{t("MomentumStrategyIs1.1")}</p>
                    <p>{t("MomentumStrategyIs1.2")}</p>
                    <p>{t("MomentumStrategyIs1.3")}</p>
                    <p>{t("MomentumStrategyIs1.4")}</p>
                    <p>{t("MomentumStrategyIs2")}</p>
                    {/* <p>{t("jumpingOnMoving")}</p> */}

                    {/* <ul className="num_lists_guide">
                      <li>
                        <h3 className="mt-2">{t("BotConstantly")}</h3>
                        <p className="mb-0">{t("Cryptocurrencies")}</p>
                      </li>
                      <li>
                        <h3 className="mt-2">{t("RisingFast")}</h3>
                        <p className="mb-0">{t("BotAutomatically")}</p>
                      </li>
                      <li>
                        <h3 className="mt-2">{t("SmallProfit")}</h3>
                        <p className="mb-0">{t("ItSellsTheCoin")}</p>
                      </li>
                      <li>
                        <h3 className="mt-2">{t("StartsLooking")}</h3>
                        <p className="mb-0">{t("ProcessRuns")}</p>
                      </li>
                    </ul> */}

                    <h3>3. {t("Risk&Security")}</h3>
                    <h3>{t("WhoControlsTheFunds")}</h3>
                    <p>{t("YouDo")}</p>
                    <ul>
                      {t("YouDo1") && <li>{t("YouDo1")}</li>}
                      {t("YouDo2") && <li>{t("YouDo2")}</li>}
                      {t("YouDo3") && <li>{t("YouDo3")}</li>}
                      {t("YouDo4") && <li>{t("YouDo4")}</li>}
                    </ul>
                    <p>{t("YouDocontent1")}</p>
                    <p>{t("YouDocontent2")}</p>

                    <h3>{t("HowIsRiskManaged")}</h3>
                    <p>{t("HowIsRiskManagedcontent1")}</p>
                    <ul>
                      {t("HowIsRiskManaged1") && <li>{t("HowIsRiskManaged1")}</li>}
                      {t("HowIsRiskManaged2") && <li>{t("HowIsRiskManaged2")}</li>}
                    </ul>
                       <p>{t("HowIsRiskManagedcontent2")}</p>
                    <ul>
                      {t("HowIsRiskManaged3") && <li>{t("HowIsRiskManaged3")}</li>}
                      {t("HowIsRiskManaged4") && <li>{t("HowIsRiskManaged4")}</li>}
                        {t("HowIsRiskManaged5") && <li>{t("HowIsRiskManaged5")}</li>}
                    </ul>
                      <p>{t("Risk_conclusion")}</p>

                    <h3>{t("BinargeUsesAdvancedSafeguards")}</h3>
                    <p>{t("BinargeUsesAdvancedSafeguardscont1")}</p>
                    <ul>
                      {t("BinargeUsesAdvancedSafeguards1") && <li>{t("BinargeUsesAdvancedSafeguards1")}</li>}
                      {t("BinargeUsesAdvancedSafeguards2") && <li>{t("BinargeUsesAdvancedSafeguards2")}</li>}
                      {t("BinargeUsesAdvancedSafeguards3") && <li>{t("BinargeUsesAdvancedSafeguards3")}</li>}
                      {t("BinargeUsesAdvancedSafeguards4") && <li>{t("BinargeUsesAdvancedSafeguards4")}</li>}
                      {t("BinargeUsesAdvancedSafeguards5") && <li>{t("BinargeUsesAdvancedSafeguards5")}</li>}
                      {t("BinargeUsesAdvancedSafeguards6") && <li>{t("BinargeUsesAdvancedSafeguards6")}</li>}
                    </ul>
                    <p>{t("BinargeUsesAdvancedSafeguardscont2")}</p>

                    <h3>{t("creditBalance")}</h3>
                    <p>{t("creditBalancecont1")}</p>
                    <ul>
                      {t("creditBalance1") && <li>{t("creditBalance1")}</li>}
                      {t("creditBalance2") && <li>{t("creditBalance2")}</li>}

                    </ul>
                    <p>{t("creditBalancecont4")}</p>
                    <ul>
                      {t("creditBalance3") && <li>{t("creditBalance3")}</li>}
                      {t("creditBalance4") && <li>{t("creditBalance4")}</li>}
                      {t("creditBalance5") && <li>{t("creditBalance5")}</li>}

                    </ul>
                    <p>{t("creditBalancecont2")}</p>
                    <p>{t("creditBalancecont3")}</p>

                    <h3>{t("creditBalancetop")}</h3>
                    <p>{t("creditBalancetopcont1")}</p>
                    <ul>
                      {t("creditBalancetop1") && <li>{t("creditBalancetop1")}</li>}
                      {t("creditBalancetop2") && <li>{t("creditBalancetop2")}</li>}
                    </ul>
                    <p>{t("creditBalancetopcont2")}</p>
                    <h5>{t("creditBalancetophead1")}</h5>
                    <p>{t("creditBalancetophead1conteent1")}</p>
                    <p>{t("creditBalancetophead1conteent1.1")}</p>
                    <p>{t("creditBalancetophead1conteent1.2")}</p>
                    <p>{t("creditBalancetophead1conteent1.3")}</p>
                    <ul>
                      {t("creditBalancetophead1conteent1.3.1") && <li>{t("creditBalancetophead1conteent1.3.1")}</li>}
                      {t("creditBalancetophead1conteent1.3.2") && <li>{t("creditBalancetophead1conteent1.3.2")}</li>}

                    </ul>
                    <p>{t("creditBalancetophead1conteent1.4")}</p>
                    <p>{t("creditBalancetophead1conteent1.5")}</p>



                    <h5>{t("creditBalancetophead2")}</h5>
                    <p>{t("MetaMask_wallet")}</p>
                    <p>{t("Basic_flow")}</p>
                    <p>{t("Add__Prepayment")}</p>
                    <p>{t("Choose_the_amount")}</p>
                    <p>{t("You_instruct")}</p>
                    <ul>
                      <li>{t("receiving_address")}</li>
                      <li>{t("BNB_Chain")}</li>
                    </ul>
                    <p>{t("Open_MetaMask")}</p>
                    <p>{t("Once_confirmed")}</p>
                    <p>{t("Binarge___")}</p>
                    <ul>
                      <li>{t("trading__capital")}</li>
                      <li>{t("NOt__invest")}</li>
                      <li>{t("service__fees")}</li>
                    </ul>


                    <h5>{t("creditBalancetophead3")}</h5>
                    <p>{t("stablecoins")}</p>
                    <p>{t("How_it_works")}</p>
                    <p>{t("Binarge__dashboard")}</p>
                    {t("Crpto_shell") && <p>{t("Crpto_shell")}</p>}
                    <ul>
                      <li>{t("CryptoAdd__Prepayment")}</li>
                      {t("CryptoAdd__Prepayment2") && <li>{t("CryptoAdd__Prepayment2")}</li>}
                    </ul>
                    <p>{t("personal__USDC")}</p>
                    <p>{t("Openany__exchange")}</p>
                    <p>{t("Select__")}</p>
                    {t("Withdraw__Crypto") &&
                    <ul>
                      <li>{t("Withdraw__Crypto")}</li>
                      <li>{t("Token__USDC")}</li>
                    </ul>}
                    <p>{t("address__provided")}</p>
                    <p>{t("correct__network")}</p>
                    <p>{t("Confirm_the_transaction")}</p>
                    <p>{t("confirmed_on_chain")}</p>
                      {t("updates_automatically") &&
                    <ul>
                      <li>{t("updates_automatically")}</li>
                      <li>{t("never_mixed")}</li>
                    </ul>}
                    <p>{t("Any_Service")}</p>
                    <h3>{t("Balance_is_sufficient")}</h3>
                   {t("Balance_is_sufficient1") &&
                    <ul>
                        {t("Balance_is_sufficient1") && <li>{t("Balance_is_sufficient1")}</li>}
                    {t("Balance_is_sufficient2") && <li>{t("Balance_is_sufficient2")}</li>}
                    </ul>
                  } 
                    <p>{t("The_dashboard")}</p>
                    <ul>
                      <li>{t("current_credit_balance")}</li>
                      <li>{t("notifications")}</li>
                      <li>{t("missing_balance")}</li>
                    </ul>


                     {t("Registration_title") && <h3>{t("Registration_title")}</h3>}
                    <h3>{t("__Registration__")}</h3>
                    <p>{t("Register_List1")}</p>
                    <p>{t("Register_List2")}</p>
                    <p>{t("Register_List3")}</p>

                    <h3>{t("activate__subscription_plan")}</h3>
                    <p>{t("bot__start")}</p>
                    <p>{t("subscriptionplan__follows")}</p>
                    <ul>
                      <li>{t("freemium__")}</li>
                      <li>{t("Premium__")}</li>
                      <li>{t("Promium__")}</li>
                      <li>{t("Elite__Trader")}</li>
                    </ul>
                    <p>{t("Activate_the_subscription")}</p>
                    <ul>
                      <li>{t("Binarge___software")}</li>
                      <li>{t("capital__stays")}</li>
                    </ul>

                    <h3>{t("upfront__payment")}</h3>
                    <p>{t("enough_prepayment")}</p>
                    <p>{t("enough_prepayment_follows")}</p>
                    <ul>
                      <li>{t("pre__paid")}</li>
                      <li>{t("cover__subscription")}</li>
                      <li>{t("service__access")}</li>
                    </ul>

                    <h3>{t("profit__sharing__fees")}</h3>
                    <p>{t("equivalent__")}</p>
                    <p>{t("service__wallet")}</p>
                    <p>{t("your__exchange")}</p>
                    <h3>{t("cw_follows")}</h3>
                    <ul>
                      <li>{t("cw_List1")}</li>
                      <li>{t("cw_List2")}</li>
                    </ul>
                    <h3>{t("Transfer__tool")}</h3>
                    <p>{t("Trans_FER_move")}</p>
                    <p>{t("Trans_FER_")}</p>
                    {t("This_Allow") && <p>{t("This_Allow")}</p>}
                    <ul>
                      {t("profit__sharing") && <li>{t("profit__sharing")}</li>}
                      {t("interruptions") && <li>{t("interruptions")}</li>}
                      {t("avoid_constantly") && <li>{t("avoid_constantly")}</li>}
                    </ul>
                    <p>{t("external__wallets")}</p>
                    <p>{t("twoservice__balances")}</p>
                    <p>{t("Minimum_credit_wallet")}</p>
                    <ul>
                      <li>{t("operate__without")}</li>
                      <li>{t("model_Binarge")}</li>
                      <li>{t("separate_service__balance")}</li>
                    </ul>

                    <h3>{t("exchange__API")}</h3>
                    <p>{t("Sub_price")}</p>
                    <p>{t("Bybit__")}</p>
                    <p>{t("API__Management")}</p>
                    <p>{t("BinargeBot__")}</p>
                    <p>{t("Allow__only")}</p>
                    <ul>
                      <li>{t("Spot_trade")}</li>
                      <li>{t("Universal_Truth")}</li>
                    </ul>
                    <p>{t("Not__allow")}</p>
                    <ul>
                      <li>{t("With_Drawals")}</li>
                      <li>{t("Ext_trans")}</li>
                      <li>{t("Wallet_permit")}</li>
                    </ul>
                    <p>{t("sk_KEY")}</p>
                    <p>{t("iP_RESTRICT")}</p>


                    <h3>{t("Bot_activation")}</h3>
                    <p>{t("Momentum")}</p>
                    <p>{t("Policy__Pack")}</p>
                    <ul>
                      {t("Mrl") && <li>{t("Mrl")}</li>}
                      {t("Mdo") && <li>{t("Mdo")}</li>}
                      {t("Mdt") && <li>{t("Mdt")}</li>}
                      {t("Dlt") && <li>{t("Dlt")}</li>}
                      {t("RPt") && <li>{t("RPt")}</li>}
                      {t("T_U") && <li>{t("T_U")}</li>}
                    </ul>
                    <p>{t("Accept_things")}</p>
                    <p>{t("Activate_bot")}</p>
                    <p>{t("Operte_Automatically")}</p>
                    <ul>
                      <li>{t("Sub_Act")}</li>
                      <li>{t("Sufficient_fund")}</li>
                      <li>{t("At_least_fund")}</li>
                      <li>{t("Api_work_connect")}</li>
                      <li>{t("PolicY__Accepted")}</li>
                    </ul>

                    <h3>{t("SHARING_CREDIT_BALANCE")}</h3>
                    <h3>{t("WhatisProfitSharing?")}</h3>
                    <p>{t("performance_based")}</p>
                    <ul>
                      <li>{t("Ps_list_1")}</li>
                      <li>{t("Ps_list_2")}</li>
                      <li>{t("Ps_list_3")}</li>
                    </ul>
                    <p>{t("subscription__level")}</p>
                    <ul>
                      <li>{t("Monthly_fee")}</li>
                      <li>{t("Profit_sharing_percentage")}</li>
                    </ul>

                    <h3>{t("HowisProfitSharingcalculated?")}</h3>
                    <p>{t("deducted__")}</p>
                    <p>{t("strategy__cycle")}</p>
                    <p>{t("profit_is_confirmed")}</p>
                    <p>{t("Binarge__calculates")}</p>
                    <p>{t("Important__")}</p>
                    <ul>
                      <li>{t("never__")}</li>
                      <li>{t("Credit__Balance")}</li>
                    </ul>

                    <h3>{t("WhatistheCreditBalanceinpractice?")}</h3>
                    <p>{t("Credit___Balance")}</p>
                    <ul>
                      <li>{t("practice_list1")}</li>
                      <li>{t("practice_list2")}</li>
                      <li>{t("practice_list3")}</li>
                      <li>{t("practice_list4")}</li>
                    </ul>

                    <h3>{t("SAFETY_ENGINE")}</h3>
                    <p>{t("Binarge_safety_engine")}</p>
                    <h3>{t("Max_order_Limit")}</h3>
                    <p>{t("Max_size")}</p>
                    {t("Max_Size_follows") && <p>{t("Max_Size_follows")}</p>}
                    <ul>
                      <li>{t("R_pt")}</li>
                      <li>{t("Amount_of_capital")}</li>
                      <li>{t("exchange_technical_Limits")}</li>
                    </ul>
                    <p>{t("Bigger_limits")}</p>

                    <h3>{t("Max_open_trades")}</h3>
                    <p>{t("Opened_trade")}</p>
                    <p>{t("Limit_Reached")}</p>

                    <h3>{t("Max_dailt_trades")}</h3>
                    <p>{t("OPen_close")}</p>
                    <p>{t("excessive_volume")}</p>

                    <h3>{t("Daily_loss_limit")}</h3>
                    <p>{t("def_percentage")}</p>
                    <p>{t("Open_Positions")}</p>
                    <p>{t("Paused_mode")}</p>
                    <p>{t("user_confirmation")}</p>

                    <h3>{t("Policy_pac_confirm")}</h3>
                    <p>{t("summary_of")}</p>
                    <ul>
                      <li>{t("Mdo__list1")}</li>
                      <li>{t("Mdt__List2")}</li>
                      <li>{t("Dlt__List3")}</li>
                      <li>{t("Rpt__per")}</li>
                      <li>{t("T__univer")}</li>
                    </ul>
                    <p>{t("Act_vate_bot")}</p>

                    <h3>{t("Bot_Logic")}</h3>
                    <h3>{t("Strategy_Priority_Logic")}</h3>
                    <p>{t("technical_conditions")}</p>
                    <p>{t("Internal_Priority")}</p>
                    <p>{t("Triangular")}</p>
                    <p>{t("Short_Term")}</p>
                    <p>{t("Trend_following")}</p>
                    <p>{t("Technical_executability")}</p>

                    <h3>{t("Cooldown_Logic")}</h3>
                    <p>{t("Reasons_for_waiting")}</p>
                    <ul>
                      <li>{t("internal_cooldown")}</li>
                      <li>{t("fully_confirmed")}</li>
                      <li>{t("liquidity")}</li>
                      <li>{t("sufficient_for_arbitrage")}</li>
                      <li>{t("too_chaotic")}</li>
                    </ul>
                    <p>{t("Protection")}</p>

                    <h3>{t("Trade_lifecycle")}</h3>
                    <p>{t("Market_scanning")}</p>
                    <p>{t("Signal_detection")}</p>
                    <p>{t("technical_metrics")}</p>
                    <p>{t("Pre-check")}</p>
                    <p>{t("Order_execution")}</p>
                    <p>{t("Position__monitoring")}</p>
                    <p>{t("Position__closing")}</p>
                    <p>{t("Profit_sharing_calculation")}</p>
                    <p>{t("Optional_transfe")}</p>
                    <p>{t("Reporting_Dash")}</p>

                    <h3>{t("universal_transfer")}</h3>
                    <h3>{t("Read_api")}</h3>
                    <p>{t("Dash_board_shows")}</p>
                    <ul>
                      <li>{t("ut_List1")}</li>
                      <li>{t("ut_List2")}</li>
                      <li>{t("ut_List3")}</li>
                      <li>{t("ut_List4")}</li>
                      <li>{t("ut_List5")}</li>
                    </ul>
                    <p>{t("Stop_Automatically")}</p>

                    <h3>{t("Spot_funding")}</h3>
                    <p>{t("Ut_transfer")}</p>
                    <ul>
                      <li>{t("Same_exchange")}</li>
                      <li>{t("Funding_wallet")}</li>
                      <li>{t("Withdraw_funds")}</li>
                      <li>{t("Base_capital")}</li>
                    </ul>
                    <p>{t("Move_exchange")}</p>


                    <h3>{t("Safety_feat")}</h3>
                    <h3>{t("Strtergy")}</h3>
                    <p>{t("exam")}</p>
                    <ul>
                      <li>{t("sf_list1")}</li>
                      <li>{t("sf_list2")}</li>
                      <li>{t("sf_list3")}</li>
                      <li>{t("sf_list4")}</li>
                      <li>{t("sf_list5")}</li>
                    </ul>

                    <h3>{t("Alerts&Msg")}</h3>
                    <p>{t("Dashboard_may")}</p>
                    <ul>
                      <li>{t("Low_credit_bal")}</li>
                      <li>{t("APi_disconnect")}</li>
                      <li>{t("Policy_pack_lack_limit")}</li>
                    </ul>

                    <h3>{t("Bot_resume")}</h3>
                    <p>{t("You_activate")}</p>
                    <ul>
                      {t("Br_List1") &&<li>{t("Br_List1")}</li>}
                      <li>{t("Br_list1")}</li>
                      <li>{t("Br_list2")}</li>
                      <li>{t("Br_list3")}</li>
                    
                    </ul>
                    <p>{t("Manually_stop")}</p>

                    <h3>{t("capitilize_size")}</h3>
                    <p>{t("EurOfCapital")}</p>
                    <p>{t("An_error")}</p>
                    <ul>
                      <li>{t("capital_List1")}</li>
                      <li>{t("capital_List2")}</li>
                      <li>{t("capital_List3")}</li>
                      <li>{t("capital_List4")}</li>
                      <li>{t("capital_List5")}</li>
                    </ul>
                    <p>{t("Same_as_Profit")}</p>
                    <p>{t("Tech_rules")}</p>












































                    {/* <p>{t("HowIsRiskManagedcontent3")}</p>
                    <ul>
                      <li>{t("Max2%Capital")}</li>
                      <li>{t("OnlyHighliquidityPairs")}</li>
                      <li>{t("NoGuessing")}</li>
                      <li>{t("NoWithdrawal")}</li>
                    </ul> */}
                    {/* <h3> {t("WhatIsTheFuelWallet")}</h3>
                    <p>{t("FuelWalletIsUsedToCover")}</p>

                    <h3> 4. {t("GettingStarted")}</h3>
                    <h3> {t("HowToRegisterAndConnectYourExchange")}</h3>
                    <p>{t("GoToBinarge")}</p>

                    <h3> {t("HowToFundTheFuelWallet")}</h3>
                    <p>
                      {t("Depositusdt")}
                    </p>

                    <h3> {t("HowToTrackPerformance")}</h3>
                    <p>
                      {t("YouCanMonitorTrades")}
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SubFooter />
    </>
  );
};

export default BinargeAcademy;
